const createTooltipContent = ({
  postId,
  title,
  description,
  imageAlt,
  imageUrl,
  imageSizeDesktop,
  imageSizeTablet,
  imageSizeMobile,
  url,
  index
}) => {
  return `
    <aside class="dlr-interactive-body-content__tooltip" data-id="${postId}" role="dialog" aria-modal="true" tabindex="${index}">
      <div class="dlr-interactive-body-content__tooltip-header">
        <button class="dlr-interactive-body-content__btn dlr-interactive-body-content__tooltip-close-btn" aria-label="Close Tooltip">
          <span>Close</span>
          <svg class="close-icon" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill="var(--cta-text-color)" fill-rule="evenodd" clip-rule="evenodd" d="M5.52088 6.58175L0.0848282 12.0208L1.14519 13.0818L6.58154 7.64241L12.0175 13.0783L13.0781 12.0177L7.64191 6.58145L13.1593 1.06095L12.099 0L6.58125 5.52079L1.06066 0.000203714L0 1.06086L5.52088 6.58175Z"></path>
          </svg>
        </button>
        <h4 class="dlr-interactive-body-content__tooltip-heading">Overview</h4>
      </div>
      <div class="dlr-interactive-body-content__tooltip-media">
        <figure class="dlr-media dlr-interactive-body-content__tooltip-image --cover">
          <picture>
            <source media="(min-width: 62.5rem)" srcset="${imageSizeDesktop}">
            <source media="(min-width: 48rem)" srcset="${imageSizeTablet}">
            <source media="(min-width: 0rem)" srcset="${imageSizeMobile}">
            <img src="${imageUrl}" alt="${imageAlt}" title="${title}">
          </picture>
        </figure>
      </div>
      <h5 class="dlr-interactive-body-content__tooltip-title">${title}</h5>
      <p class="dlr-interactive-body-content__tooltip-excerpt">${description}</p>
      <div class="dlr-interactive-body-content__tooltip-cta">
        <a class="dlr-interactive-body-content__cta dlr-cta" href="${url}">Read More</a>
      </div>
    </aside>
  `;
};

export default createTooltipContent;



// WEBPACK FOOTER //
// ../views/modules/interactive-body-content/createTooltipContent.js